import _ from 'lodash';

export const cleanQuery = query => _.replace(_.kebabCase(_.deburr(query)), '-', '');



// WEBPACK FOOTER //
// ./src/services/search/utils.js